import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
  Stack
} from "@mui/material";
import DeleteImage from '../../assets/delete-img-modal.svg';
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

const DeleteHopConfirmationDialog = ({ open, onClose, onConfirm, hopName }: any) => {
  const theme = useTheme();
  const colors = theme.palette;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true} 
      maxWidth="md"
    >
      <Box p={2} bgcolor="blue.darker">
        <DialogTitle
          sx={{
            p: '8px 16px !important',
          }}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="widgetTitle" flexGrow={1}>
              Delete Hop
            </Typography>
            <Box>
              <IconButton onClick={onClose} sx={{ color: "white.main" }}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ backgroundColor: colors.modal.bg, color: colors.modal.text}}>
          <Stack direction="row" spacing={2} sx={{ pt: 2 }}>
            <Box component="img" src={DeleteImage} alt="" />
            <Stack spacing={2}>
              <Typography fontSize="28px" fontWeight={600} sx={{ color: colors.modal.text }}>
                Are you sure you want to delete{" "}
                  {hopName ? `"${hopName}"` : "hop"}?
              </Typography>
              <Typography variant="body1" sx={{ color: colors.modal.text }}>
                This hop will be removed from workflow.
              </Typography>
            </Stack>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ backgroundColor: colors.modal.bg }}>
          <Button onClick={onClose} variant="pepwiseOutline" sx={{ color: `${colors.buttons.primary.textColor} !important `}}>
            CANCEL
          </Button>
          <Button onClick={onConfirm} variant="pepwiseError">
            DELETE
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default DeleteHopConfirmationDialog;